import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    Col,
    Container,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    NavbarBrand,
    Offcanvas,
    OffcanvasBody,
    OffcanvasHeader,
    Row
} from 'reactstrap';
import { GetMemberInfoAPI } from '../../helpers/APIS/CommonApisSchema';
import AssessmentsListPopup from '../../pages/Assessments/AssessmentsListPopup';
import { logoutAction } from '../../Store/callAPI/actions';
import { DataKey } from '../../Store/callAPI/allAPIs';
import { SelectFullStateOfThisAPI } from '../../Store/callAPI/selectors';
import { SelectSearchValInStore } from '../../Store/commonStore/selectors';
import { getSpecificTenantLogo } from '../../utils/Utils';
import { headerMenuItems } from '../constants/CommonConstants';

const StaticNavbar = () => {
    const history = useNavigate();
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const [isMenuDropdown, setIsMenuDropdown] = useState(false);
    const [showAssessmentPopUp, setShowAssessmentPopUp] = useState(false);
    const [showCanvas, setShowCanvas] = useState(false);

    const linkParams = useSelector((state) => SelectSearchValInStore(state, 'linkParams'));
    const GetMemberInfoAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, GetMemberInfoAPI));

    let memberData = GetMemberInfoAPIData?.[DataKey]?.data;
    const assessments = GetMemberInfoAPIData?.[DataKey]?.data?.assessments || [];

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const toggleMenuDropdown = () => {
        setIsMenuDropdown(!isMenuDropdown);
    };

    const handleLogout = () => {
        logoutAction();
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem('explicitLogout', 'true');
        if (process.env.REACT_APP_IS_PROD) {
            if (linkParams?.environment === 'xp') {
                if (linkParams?.xpLang && linkParams?.xpLang !== '')
                    history(
                        `/authorize/xp/${linkParams?.lang}/${linkParams?.uniquelink}/${linkParams?.uniquekey}/${linkParams?.pageName}/${linkParams?.modeId}`
                    );
                else history(`/authorize/xp/${linkParams?.uniquelink}/${linkParams?.uniquekey}`);
            } else {
                history(`/authorize/${linkParams?.uniquelink}`);
            }
        } else {
            if (linkParams?.environment === 'xp') {
                if (linkParams?.xpLang && linkParams?.xpLang !== '')
                    history(
                        `${linkParams?.tenant !== 'ggh' ? linkParams?.tenant : ''}/authorize/xp/${linkParams?.lang}/${
                            linkParams?.uniquelink
                        }/${linkParams?.uniquekey}/${linkParams?.pageName}/${linkParams?.modeId}`
                    );
                else history(`/authorize/xp/${linkParams?.uniquelink}/${linkParams?.uniquekey}`);
            } else {
                history(`/authorize/${linkParams?.uniquelink}`);
            }
        }
    };

    const navigateToCarePlanAuth = () => {
        const hasVisitedCarePlan = sessionStorage.getItem('hasVisitedCarePlan') === 'true';

        if (hasVisitedCarePlan) {
            history('/careplan');
        } else {
            logoutAction();
            localStorage.clear();
            sessionStorage.clear();

            const tenantPart = linkParams?.tenant && linkParams?.tenant !== 'ggh' ? `/${linkParams?.tenant}` : '';
            const langPart = linkParams?.lang ? `/${linkParams?.lang}` : '';

            if (linkParams?.environment === 'xp') {
                history(`${tenantPart}/authorize/xp${langPart}/${linkParams?.uniquelink}/${linkParams?.uniquekey}`);
            } else {
                history(`/authorize/${linkParams?.uniquelink}`);
            }
        }
    };

    const handleMenuItemClick = (memnuItem) => {
        if (memnuItem.id === 1) {
            assessments?.length === 1
                ? history('/assessments', { state: { assessmentData: assessments[0] } })
                : setShowAssessmentPopUp(true);
        } else {
            navigateToCarePlanAuth();
        }
    };

    return (
        // <Navbar fixed="top" light expand="md" className="navbar-bg-light">
        <Container fluid className="bg-white mb-2 pe-0">
            <Row className="w-100 align-items-center">
                <Col className="d-flex justify-content-between align-items-center">
                    <NavbarBrand className="cursor-pointer" onClick={navigateToCarePlanAuth}>
                        {getSpecificTenantLogo(linkParams?.tenant)}
                    </NavbarBrand>
                    <div className="d-flex align-items-center mobile-view-hide ">
                        {/* Menu Icon Dropdown */}
                        <Dropdown isOpen={isMenuDropdown} toggle={toggleMenuDropdown} id="menuDropdown" className=" me-4">
                            <DropdownToggle className="btn btn-soft-primary btn-icon btn-sm sm-btn" tag="button">
                                <i className="ri-menu-line fs-4 p-2"></i>
                            </DropdownToggle>

                            <DropdownMenu>
                                {headerMenuItems(linkParams?.tenant).map((item, idx) => (
                                    <DropdownItem
                                        key={item?.id || item.label || idx}
                                        onClick={() => handleMenuItemClick(item)}
                                        className="py-2"
                                    >
                                        {item.label}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>

                        <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="topbar-user p-2 " id="profileSelect">
                            <DropdownToggle className="border-0 d-flex align-items-center" tag="button">
                                <span className="rounded-circle bg-primary d-flex justify-content-center align-items-center me-2 text-white fw-semibold text-uppercase avatar-profile">
                                    {memberData?.fullName
                                        ? memberData.fullName
                                              .split(' ')
                                              .map((word) => word[0])
                                              .join('')
                                              .substring(0, 2)
                                              .toUpperCase()
                                        : ''}
                                </span>
                                <span className="fw-semibold text-dark">
                                    {memberData?.fullName
                                        ? memberData.fullName
                                              .split(' ')
                                              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                              .join(' ')
                                        : ''}
                                </span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <h6 className="dropdown-header">Welcome {memberData?.fullName}</h6>
                                <DropdownItem onClick={handleLogout}>
                                    <i className="ri-logout-box-r-line text-muted fs-16 align-middle me-1"></i>
                                    <span className="align-middle" data-key="t-logout">
                                        Logout
                                    </span>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className="mobile-view-show">
                        <button type="button" className="btn btn-soft-primary btn-icon btn-sm sm-btn" onClick={() => setShowCanvas(true)}>
                            <i className="ri-menu-line fs-4 p-2" />
                        </button>
                    </div>
                    <Offcanvas isOpen={showCanvas} toggle={() => setShowCanvas(false)} direction="end" className="offcanvas-menu w-50 p-0">
                        <OffcanvasHeader
                            toggle={() => setShowCanvas(false)}
                            className="d-flex justify-content-between align-items-center p-2"
                        >
                            <h5 className="mb-0 d-flex align-items-center">
                                <span className="rounded-circle bg-primary d-flex justify-content-center align-items-center me-2 text-white  text-uppercase avatar-profile">
                                    {memberData?.fullName
                                        ? memberData.fullName
                                              .split(' ')
                                              .map((word) => word[0])
                                              .join('')
                                              .substring(0, 2)
                                              .toUpperCase()
                                        : ''}
                                </span>
                                <span className=" text-dark">
                                    {memberData?.fullName
                                        ? memberData.fullName
                                              .split(' ')
                                              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                              .join(' ')
                                        : ''}
                                </span>
                            </h5>
                        </OffcanvasHeader>

                        <OffcanvasBody className="p-0">
                            <ul className="list-unstyled static-navbar m-0 p-1">
                                <li className="py-2 ">
                                    <button
                                        className="btn w-100 text-start"
                                        onClick={() => {
                                            setShowCanvas(false);
                                            assessments?.length === 1
                                                ? history('/assessments', { state: { assessmentData: assessments[0] } })
                                                : setShowAssessmentPopUp(true);
                                        }}
                                    >
                                        Assessments
                                    </button>
                                </li>
                                <li className="py-2">
                                    <button className="btn  w-100 text-start" onClick={navigateToCarePlanAuth}>
                                        Care Plan
                                    </button>
                                </li>
                            </ul>
                        </OffcanvasBody>
                        <Button
                            onClick={handleLogout}
                            className="w-100 bg-light border-0 text-dark d-flex align-items-center justify-content-center"
                        >
                            <i className="ri-logout-box-r-line text-dark fs-16 align-middle me-2"></i>
                            <span className="align-middle" data-key="t-logout">
                                Logout
                            </span>
                        </Button>
                    </Offcanvas>
                </Col>
            </Row>
            <AssessmentsListPopup show={showAssessmentPopUp} onCancel={() => setShowAssessmentPopUp(false)} />
        </Container>
        // </Navbar>
    );
};

export default StaticNavbar;
